module.exports = __webpack_public_path__ + "sk.svg?fc341bbeac39b3127714b9906dd96980";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sk.svg
// module id = 1184
// module chunks = 27